import { Typography, styled } from '@mui/material'
import LoadingSpinner from '@components/LoadingSpinner'
import { useTranslation } from 'react-i18next'

const DialogWrapper = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  height: '100%',
  width: '100%',
  flex: 1,
  gap: '1.45rem',
  color: 'var(--dewi_colors_gray_0)',
})

export const LoadingDialog = ({ title }: { title?: string }) => {
  const { t } = useTranslation()

  return (
    <DialogWrapper>
      <LoadingSpinner size={40} />
      <Typography>{title || t('generic.loadingDialog')}</Typography>
    </DialogWrapper>
  )
}
